import React from 'react';
import { Icon, mergeStyles } from '@fluentui/react';

interface ValidationMessageProps {
  message: string;
  fonts: any;
}

const iconSize: React.CSSProperties = {
  lineHeight: '16px',
  width: '16px'
};

export const errorMessageStyle: React.CSSProperties = {
  color: '#DF0000'
};

const errorMessageTextClass = fonts => {
  const errorMessageTextClass = mergeStyles(
    {
      top: 2,
      lineHeight: fonts.small.lineHeight,
      fontFamily: fonts.small.fontFamily,
      fontSize: fonts.small.fontSize
    },
    'position-relative'
  );
  return errorMessageTextClass;
};

export const ValidationMessage: React.FC<ValidationMessageProps> = props => {
  return (
    <div style={{ height: '15px' }} role="alert" aria-live="assertive">
      <div className="mt-1 text-nowrap" style={errorMessageStyle}>
        <Icon style={iconSize} className="align-middle" iconName={'AlertSolid'} />
        <span className={errorMessageTextClass(props.fonts)}>{props.message}</span>
      </div>
    </div>
  );
};
